import { Navigate } from "react-router";
import SignInScreen from "../pages/auth/sign-in-screen";
import SignUpScreen from "../pages/auth/sign-up-screen";

const authRoutes = [
  { path: "login", element: <SignInScreen /> },
  { path: "signup", element: <SignUpScreen /> },
  { path: "", element: <Navigate to="/404" /> },
];

export default authRoutes;
